/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Which candidate-facing explanation panel to show after a completed Persona inquiry.
 */
export type PersonaCandidatePrompt =
  (typeof PersonaCandidatePrompt)[keyof typeof PersonaCandidatePrompt];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PersonaCandidatePrompt = {
  none: 'none',
  selfie_mismatch: 'selfie_mismatch',
  id_incomplete: 'id_incomplete',
  id_expired: 'id_expired',
  missing_extracted_properties: 'missing_extracted_properties',
  missing_name: 'missing_name',
} as const;
